import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { fetchServer } from "../Base/modelManager";

class ContactEditor extends React.Component {
    constructor(props){
        super(props)
     
        this.state={
            record:props.record
        }
    }

    onSave = () => {
        const { record } = this.state
       
        const request = {
            endPoint: this.props.apiUrl + '/Services/Clients/Contact' ,
            method: 'PATCH',
            token: this.props.JWTToken,
            params: {
                clientid: this.props.currentClient.uid,
                values : {...record}
            }
        }

        fetchServer(request,
             () => {this.props.onClose()},
            ()=>{})

    }

    onPropertyChanged = (e) => {
        const { record } = this.state


        record[e.target.name] = e.target.value
        
        this.setState({ record: { ...record } })
    }

    onCheckBoxChanged = (e) => {
        const { record } = this.state

      
        record[e.target.name] = e.target.checked
        
        this.setState({ record: { ...record } })
    }


    render() {
        const { record } = this.state



        return (
            <Container className="editorFunction">
                <Form>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                           Nom
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.nom} name="nom" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Prenom
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.prenom} name="prenom" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Fonction
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.fonction} name="fonction" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Courriel
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.email} name="email" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Téléphone
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.telephone} name="telephone" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Mobile
                        </Form.Label>
                        <Col sm="8">
                            <Form.Control as="input" value={record.Mobile} name="Mobile" onChange={(e) => this.onPropertyChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Reception des factures
                        </Form.Label>
                        <Col sm="8">
                            <Form.Check type="checkbox" checked={record.emailFact} name="emailFact" onChange={(e) => this.onCheckBoxChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Accès Espace Client
                        </Form.Label>
                        <Col sm="8">
                            <Form.Check type="checkbox" checked={record.espaceClient} name="espaceClient" onChange={(e) => this.onCheckBoxChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Gestion de l'espace client
                        </Form.Label>
                        <Col sm="8">
                            <Form.Check type="checkbox" checked={record.gestion} name="gestion" onChange={(e) => this.onCheckBoxChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Commande de support
                        </Form.Label>
                        <Col sm="8">
                            <Form.Check type="checkbox" checked={record.commande} name="commande" onChange={(e) => this.onCheckBoxChanged(e)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="FormItem">
                        <Form.Label column sm="4">
                            Gestion du plafond
                        </Form.Label>
                        <Col sm="8">
                            <Form.Check type="checkbox" checked={record.plafond} name="plafond" onChange={(e) => this.onCheckBoxChanged(e)} />
                        </Col>
                    </Form.Group>
                </Form>


                
                
               

              

                <Row className="FormButtonBar">
                    <Col  style={{textAlign:'center'}}>
                        <Button className='frmCancel' onClick={() => this.props.onClose()}  style={{  color:   'white',  backgroundColor: '#24b5b9'}}>Annuler</Button>
                    </Col>
                    {this.props.currentClient.gestion===true ?
                    <Col style={{textAlign:'center'}}>
                        <Button  className='frmSubmit' onClick={this.onSave}  style={{  color:   'white',  backgroundColor: '#24b5b9'}}>Enregistrer</Button>
                    </Col>
                    :null
                    }
                </Row>
            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

ContactEditor.propTypes = {
    dispatch: PropTypes.func,
    apiUrl: PropTypes.string,
    record: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    onClose: PropTypes.func
};

export default connect(mapStateToProps)(ContactEditor);
